import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import styles from './index.module.css'

const Header = data => (
  <div className={styles.logo}>
    <Link to="/editorial">
      <Img className={styles.img} sizes={data.data.logo.childImageSharp.sizes} alt="Logo" />
    </Link>
    <div className={styles.imgtext}>
      <Link to="/editorial">
        <Img sizes={data.data.logotext.childImageSharp.sizes} alt="Logo" />
      </Link>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Logo/index.js